import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import qs from 'qs';
import { saleSet, saleLookup } from 'state/actions/sales';
import { invoiceRequest } from 'state/actions/invoices';
import Layout from 'components/Layout';
import Title from 'components/Title';
import RequestInvoiceForm from 'components/RequestInvoiceForm';
import SuccessStatus from 'components/SuccessStatus';
import Loading from 'components/Loading';
import ErrorMessage from 'components/ErrorMessage';
import classes from './RequestInvoice.module.scss';

const RequestInvoice = () => {
  const {
    saleNumber,
    saleTotal,
    token,
    customer,
    sale,
    salesError,
    loadingSales,
    error,
    loadingInvoices,
    invoicesSuccess,
  } = useSelector(
    (state) => ({
      saleNumber: state.sales.number,
      saleTotal: state.sales.total,
      token: state.sales.token,
      customer: state.sales.customer,
      sale: state.sales.sale,
      salesError: state.sales.error,
      loadingSales: state.sales.loading,
      error: state.invoices.error,
      loadingInvoices: state.invoices.loading,
      invoicesSuccess: state.invoices.success,
    }),
    shallowEqual
  );

  const history = useHistory();

  const location = useLocation();

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    if (salesError || !queryParams.saleNumber || !queryParams.saleTotal) {
      history.push('/');
    }
  }, [salesError]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!saleNumber && !saleTotal) {
      dispatch(
        saleSet({
          number: queryParams.saleNumber,
          total: queryParams.saleTotal,
        })
      );
    }
  }, [dispatch, saleNumber, saleTotal]);

  useEffect(() => {
    if (queryParams.saleNumber && queryParams.saleTotal) {
      dispatch(
        saleLookup({
          number: queryParams.saleNumber,
          total: queryParams.saleTotal,
        })
      );
    }
  }, [dispatch]);

  const loading = loadingSales || loadingInvoices;

  const requestInfo = {
    sale: {
      ...sale,
    },
    customer: {
      ...customer,
    },
  };

  const onSubmitHandler = (formInfo) => {
    const requestBody = {
      ...requestInfo,
      token,
      sale: {
        ...requestInfo.sale,
        ...formInfo.sale,
      },
      customer: {
        ...requestInfo.customer,
        ...formInfo.customer,
      },
    };

    if (
      Object.values(requestBody.sale.billingAddress).every((value) => !value)
    ) {
      delete requestBody.sale.billingAddress;
    }
    dispatch(invoiceRequest(requestBody));
  };

  return (
    <Layout>
      {loadingSales && <Loading />}
      {loadingInvoices && (
        <Loading>Generando factura, no abandone la página...</Loading>
      )}
      {!loading && !invoicesSuccess && (
        <div className={classes.requestInvoiceContainer}>
          <div className={classes.requestInvoiceFormContainer}>
            <Title>Información de Facturación</Title>
            {error && <ErrorMessage>{error.message}</ErrorMessage>}
            {!invoicesSuccess && (
              <RequestInvoiceForm
                requestInfo={requestInfo}
                onSubmitHandler={onSubmitHandler}
              />
            )}
          </div>
        </div>
      )}
      {!loading && invoicesSuccess && (
        <SuccessStatus>
          La factura fue solicitada y se enviará a tu mail.
        </SuccessStatus>
      )}
    </Layout>
  );
};

export default RequestInvoice;
